/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Season_Mid_Season_TooltipInputs */



/**
* | output |
* | --- |
* | "Outdoor temperature (Text) Non-heating temperature (TNC) Heating temperature (TC) Delay (Tempo) The boiler room switches to summer mode if Text > TNC for Tem..." |
*
* @param {Season_Mid_Season_TooltipInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const season_mid_season_tooltip = /** @type {((inputs?: Season_Mid_Season_TooltipInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Season_Mid_Season_TooltipInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Outdoor temperature (Text)\nNon-heating temperature (TNC)\nHeating temperature (TC)\nDelay (Tempo)\n\nThe boiler room switches to summer mode if Text > TNC for Tempo\nThe boiler room switches to winter mode if Text < TC for Tempo\nThe boiler room keeps its mode if TC < Text < TNC")
	return /** @type {LocalizedString} */ ("Température extérieure (Text)\nTempérature de non chauffage (TNC)\nTempérature de chauffage (TC)\nTemporisation (Tempo)\n\nLa chaufferie est en fonctionnement été si Text > TNC pendant Tempo\nLa chaufferie est en fonctionnement hiver si Text < TC pendant Tempo\nLa chaufferie garde son fonctionnement si TC < Text < TNC")
});